/**
 * Money in the «Всё видно» interface: Russian grouping, whole units,
 * e.g. "1 200 000 ₽". The currency comes from the CRM configuration.
 */
export const formatCurrency = (amount: number, currency: string): string =>
  new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 0,
  }).format(amount);

/**
 * Money where space is tight (kanban cards and column totals, ~140 px):
 * "1,2 млн ₽", "350 тыс. ₽", "950 ₽".
 */
export const formatCompactCurrency = (
  amount: number,
  currency: string,
): string =>
  new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    notation: "compact",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(amount);
